<template>
  <div class="index">
    <router-view />
    <van-tabbar v-model="active" route safe-area-inset-bottom active-color="#1989fa" inactive-color="#969799">
      <van-tabbar-item to="/home" icon="home-o">首页</van-tabbar-item>
      <van-tabbar-item to="/bill" icon="balance-list-o">还款</van-tabbar-item>
      <van-tabbar-item to="/service" icon="service-o">客服</van-tabbar-item>
      <van-tabbar-item to="/my" icon="user-o">我的</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  name: 'Index',
  data() {
    return { active: 0 }
  }
}
</script>

<style lang="less" scoped>
.index {
  height: 100%;
  background: linear-gradient(90deg, #e0f0ff, #edf6ff);
}
</style>
